<div class="container-fluid"
     style="background-color:rgb(242,242,242) !important;height:75px!important;margin-bottom:1px!important;">
    <div class="row">
        <div class="col-md-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
        <div class="col-6"></div>
        <div class="col-6">
            <div class="row">
                <div style="width: 70px;height: 70px;" *ngIf="screen=='statement'" class="col-2">
                    <div class="" title="Cancel" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                        <div class="app-cancel" (click)=" cancel()"></div>
                    </div>
                </div>
                <div style="width: 70px;height: 70px;" *ngIf="screen=='statement'" class="col-2">
                    <div class="" title="Download Statement" style="margin: 0px auto;" rel="tooltip"
                         data-placement="top">
                        <div class="download-statement" (click)="download()"></div>
                    </div>
                </div>
                <div style="width: 70px;height: 70px;" *ngIf="screen=='statement'" class="col-2">
                    <div class="" title="Email Statement" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                        <div class="email-statement" (click)="email()"></div>
                    </div>
                </div>
                <div style="width: 70px;height: 70px;" *ngIf="screen=='invoice'" class="col-2">
                    <div class="" title="Cancel" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                        <div class="app-cancel" (click)="cancel()"></div>
                    </div>
                </div>
                <div style="width: 70px;height: 70px;" *ngIf="screen=='invoice'" class="col-2">
                    <div class="" title="Download Invoice" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                        <div class="download-statement" (click)="download()"></div>
                    </div>
                </div>
                <div style="width: 70px;height: 70px;" *ngIf="screen=='invoice'" class="col-2">
                    <div  title="Email Invoice" style="margin: 0px auto;" rel="tooltip" data-placement="top">
                        <div class="email-statement" (click)="email()"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

